export default {
  root: {
    class: [
      // Shape
      "rounded-md",
      "shadow-md",

      // Color
      "bg-surface-0 dark:bg-surface-900",
      "text-surface-700 dark:text-surface-0",
      "border border-surface-200 dark:border-surface-700",
    ],
  },
  body: {
    class: "p-5",
  },
  title: {
    class: "font-hellix text-2xl font-bold mb-2",
  },
  subtitle: {
    class: [
      // Font
      "font-normal",

      // Spacing
      "mb-2",

      // Color
      "text-surface-700 dark:text-surface-0/60",
    ],
  },
  content: {
    class: "py-5", // Vertical padding.
  },
  footer: {
    class: "pt-5", // Top padding.
  },
};
